// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Fundo azul com grid sutil */
.styles_pageContainer__yEaG\\+ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 50%, #1565c0 100%);
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 24px 24px;
  padding: 1rem;
}

/* Painel branco central */
.styles_containerSection__mr6dt {
  align-items: center;
  width: 100%;
  max-width: 26rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 2rem 2.5rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.styles_containerSenhaTextField__rYdn5 {
  margin-top: 0.25rem;
  width: 100%;
}

.styles_senhaTextField__4iNs8 {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_labelField__fQFpK {
  font-family: "Inter" !important;
  font-size: 0.875rem;
  color: #424242;
  display: block;
  margin-bottom: 0.35rem;
}

.styles_title__fED6X {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.styles_title__fED6X h2 {
  font-family: "Inter";
  font-size: 1.35rem;
  font-weight: 600;
  color: #18316e;
}

.styles_container__buttons__iUaIz {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  width: 100%;
}

.styles_botaoConfirmar__2VOBT {
  background-color: #424242 !important;
  color: #ffffff !important;
  width: 100%;
  max-width: 14rem;
  padding: 10px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 8px;
  transition: background-color 0.2s, transform 0.2s;
}

.styles_botaoConfirmar_disable__NRhcq {
  background-color: #9e9e9e !important;
  color: #ffffff !important;
  width: 100%;
  max-width: 14rem;
  padding: 10px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 8px;
}

.styles_botaoConfirmar__2VOBT:hover {
  background-color: #303030 !important;
  transform: scale(0.98);
}

@media (max-width: 425px) {
  .styles_containerSection__mr6dt {
    width: 100%;
    padding: 1.5rem 1.25rem;
  }

  .styles_container__buttons__iUaIz {
    justify-content: center;
  }

  .styles_botaoConfirmar__2VOBT,
  .styles_botaoConfirmar_disable__NRhcq {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditPassword/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,0EAA0E;EAC1E;;0EAEwE;EACxE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Fundo azul com grid sutil */\n.pageContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 50%, #1565c0 100%);\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);\n  background-size: 24px 24px;\n  padding: 1rem;\n}\n\n/* Painel branco central */\n.containerSection {\n  align-items: center;\n  width: 100%;\n  max-width: 26rem;\n  gap: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  padding: 2rem 2.5rem;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.containerSenhaTextField {\n  margin-top: 0.25rem;\n  width: 100%;\n}\n\n.senhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.labelField {\n  font-family: \"Inter\" !important;\n  font-size: 0.875rem;\n  color: #424242;\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.title h2 {\n  font-family: \"Inter\";\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: #18316e;\n}\n\n.container__buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 0.5rem;\n  width: 100%;\n}\n\n.botaoConfirmar {\n  background-color: #424242 !important;\n  color: #ffffff !important;\n  width: 100%;\n  max-width: 14rem;\n  padding: 10px 24px !important;\n  font-weight: 600 !important;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-radius: 8px;\n  transition: background-color 0.2s, transform 0.2s;\n}\n\n.botaoConfirmar_disable {\n  background-color: #9e9e9e !important;\n  color: #ffffff !important;\n  width: 100%;\n  max-width: 14rem;\n  padding: 10px 24px !important;\n  font-weight: 600 !important;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-radius: 8px;\n}\n\n.botaoConfirmar:hover {\n  background-color: #303030 !important;\n  transform: scale(0.98);\n}\n\n@media (max-width: 425px) {\n  .containerSection {\n    width: 100%;\n    padding: 1.5rem 1.25rem;\n  }\n\n  .container__buttons {\n    justify-content: center;\n  }\n\n  .botaoConfirmar,\n  .botaoConfirmar_disable {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `styles_pageContainer__yEaG+`,
	"containerSection": `styles_containerSection__mr6dt`,
	"containerSenhaTextField": `styles_containerSenhaTextField__rYdn5`,
	"senhaTextField": `styles_senhaTextField__4iNs8`,
	"labelField": `styles_labelField__fQFpK`,
	"title": `styles_title__fED6X`,
	"container__buttons": `styles_container__buttons__iUaIz`,
	"botaoConfirmar": `styles_botaoConfirmar__2VOBT`,
	"botaoConfirmar_disable": `styles_botaoConfirmar_disable__NRhcq`
};
export default ___CSS_LOADER_EXPORT___;
